import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-upload\">\n<path d=\"M1.125 14.699H14.875C15.0575 14.699 15.2073 14.7575 15.3244 14.8746C15.4415 14.9917 15.5 15.1415 15.5 15.324C15.5 15.5065 15.4415 15.6563 15.3244 15.7734C15.2073 15.8905 15.0575 15.949 14.875 15.949H1.125C0.9425 15.949 0.792708 15.8905 0.675625 15.7734C0.558542 15.6563 0.5 15.5065 0.5 15.324C0.5 15.1415 0.558542 14.9917 0.675625 14.8746C0.792708 14.7575 0.9425 14.699 1.125 14.699ZM8.625 3.41026V12.1996H7.375V3.27401L2.62875 8.02026L1.75 7.14151L7.94125 0.950256L14.1325 7.14151L13.2338 8.02026L8.625 3.41026Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/upload.svg
// module id = rJM3
// module chunks = 262